var React = require('react');

function IcShareLinkDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 20a5.171 5.171 0 015.166-5.167h6.667v-3.166h-6.667A8.336 8.336 0 003.333 20c0 4.6 3.733 8.333 8.333 8.333h6.667v-3.166h-6.667A5.171 5.171 0 016.5 20zm6.834 1.667h13.333v-3.334H13.333v3.334zm8.333-10h6.666c4.6 0 8.334 3.733 8.334 8.333s-3.734 8.333-8.334 8.333h-6.666v-3.166h6.666A5.171 5.171 0 0033.5 20a5.171 5.171 0 00-5.167-5.167h-6.666v-3.166z","fill":"currentColor"}));
}

IcShareLinkDark.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IcShareLinkDark;

IcShareLinkDark.default = IcShareLinkDark;
